import { render, staticRenderFns } from "./rubric_select_from_library.vue?vue&type=template&id=7fbea116&"
import script from "./rubric_select_from_library.vue?vue&type=script&lang=js&"
export * from "./rubric_select_from_library.vue?vue&type=script&lang=js&"
import style0 from "./rubric_select_from_library.vue?vue&type=style&index=0&id=7fbea116&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports